export default __webpack_public_path__ + "static/media/frame.3858ca87.svg";